import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import he from 'he';  // Import pustaka he untuk mendecode entitas HTML
import DOMPurify from 'dompurify'; // Import DOMPurify untuk sanitasi
import './Highlight.css';

const Highlight = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Memastikan halaman tidak dimuat dalam iframe
    if (window.self !== window.top) {
      window.top.location = window.self.location;
    }
    
    // Fetch the 3 most recent posts
    axios
      .get('https://infoupiyptk.com/webupiyptk/api/post/all-post.php?limit=3&page=1')
      .then((response) => {
        console.log('Received data:', response.data);  // Cek data yang diterima

        // Akses posts dari response.data.posts dan decode HTML entitas
        if (Array.isArray(response.data.posts)) {
          const decodedPosts = response.data.posts.map((post) => ({
            ...post,
            title: DOMPurify.sanitize(he.decode(post.title)),  // Decode and sanitize title
            excerpt: DOMPurify.sanitize(he.decode(post.excerpt)),  // Decode and sanitize excerpt
          }));
          setPosts(decodedPosts);  // Menyimpan data posts setelah decode dan sanitize
        } else {
          setPosts([]);  // Jika data.posts tidak array, set posts ke array kosong
        }

        setLoading(false);
        setError(null);
      })
      .catch((error) => {
        setError('Failed to load posts');
        setLoading(false);
      });
  }, []);

  // Function to truncate text (title and excerpt)
  const truncateText = (text, length = 100) => {
    if (text.length > length) {
      return text.substring(0, length) + '...';
    }
    return text;
  };

  // Function to format the date as DD November YYYY
  const formatDate = (dateString) => {
    const options = { day: '2-digit', month: 'long', year: 'numeric' };
    const date = new Date(dateString);
    return date.toLocaleDateString('id-ID', options);
  };

  // Loading state
  if (loading) {
    return <div>Loading...</div>;
  }

  // Error state
  if (error) {
    return <div>{error}</div>;
  }

  // If posts is empty
  if (posts.length === 0) {
    return <div>No posts available</div>;
  }

  return (
    <div className="highlight">
      <div className="highlight-list">
        {posts.map((post) => (
          <div key={post.id} className="highlight-card">
            <img
              src={post.featured_image ? `https://infoupiyptk.com/webupiyptk/api/post/uploads/${post.featured_image}` : 'sample-post-image.jpg'}
              onError={(e) => { e.target.src = 'https://infoupiyptk.com/webupiyptk/api/post/uploads/sample-post-image.jpg'; e.target.onerror = null; }} // Fallback jika gambar gagal dimuat
              alt={post.title}
              className="highlight-image"
            />
            {/* Date above the title */}
            <div className="post-date">{formatDate(post.created_at)}</div>
            <h2 className="highlight-title">
              {truncateText(post.title, 70)} {/* Truncate title to 70 characters */}
            </h2>
            <p className="highlight-excerpt">
              {truncateText(post.excerpt, 200)} {/* Truncate excerpt to 200 characters */}
            </p>
            <Link to={`/post/${post.url}`} className="highlight-read-more">
              Selengkapnya
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Highlight;